import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { translate } from 'react-i18next';
import Helmet from 'react-helmet';
import ApiClient from '../../helpers/ApiClient';
import { takeRecoveryToken } from '../../helpers/passwordRecoveryToken';

export class PasswordRecovery extends Component {
  state = { username: '', email: '', password: '', confirmation: '', busy: false, ready: false, success: false, error: '', hasToken: false };

  componentDidMount() {
    this.active = true;
    this.client = new ApiClient();
    if (this.isReset()) {
      this.token = takeRecoveryToken();
      this.setState({ hasToken: !!this.token, error: this.token ? '' : 'invalid_link' });
    }
    this.client.get('/password-reset').then(() => {
      if (this.active) this.setState({ ready: true });
    }).catch(() => {
      if (this.active) this.setState({ error: 'unavailable' });
    });
  }

  componentWillUnmount() {
    this.active = false;
    this.token = '';
  }

  isReset() {
    return this.props.location.pathname === '/reset-password';
  }

  submit = async event => {
    event.preventDefault();
    if (this.state.busy || !this.state.ready || this.state.success) return;
    const { username, email, password, confirmation } = this.state;
    const reset = this.isReset();
    if (reset && (password.length < 15 || password.length > 128 || password.trim().length < 15)) {
      this.setState({ error: 'password_policy' });
      return;
    }
    if (reset && password !== confirmation) {
      this.setState({ error: 'mismatch' });
      return;
    }
    this.setState({ busy: true, error: '' });
    try {
      await this.client.post(reset ? '/password-reset/confirm' : '/password-reset/request', {
        data: reset ? { token: this.token, password } : { username: username.trim(), email: email.trim() }
      });
      this.token = '';
      if (this.active) this.setState({ success: true, busy: false, password: '', confirmation: '' });
    } catch (error) {
      const code = ['invalid_link', 'password_policy', 'rate_limited'].indexOf(error && error.code) >= 0 ? error.code : 'unavailable';
      if (this.active) this.setState({ error: code, busy: false });
    }
  };

  render() {
    const { t } = this.props;
    const reset = this.isReset();
    const { username, email, password, confirmation, busy, ready, success, error, hasToken } = this.state;
    return (
      <div className="container">
        <Helmet title={t(reset ? 'passwordRecovery.reset_title' : 'passwordRecovery.forgot_title')} meta={[{ name: 'referrer', content: 'no-referrer' }, { name: 'robots', content: 'noindex,nofollow' }]} />
        <div className="row">
          <div className="col-md-6 col-md-offset-3">
            <h1>{t(reset ? 'passwordRecovery.reset_title' : 'passwordRecovery.forgot_title')}</h1>
            {error && <div className="alert alert-danger" role="alert">{t('passwordRecovery.' + error)}</div>}
            {success ? <div className="alert alert-success" role="status">{t(reset ? 'passwordRecovery.reset_success' : 'passwordRecovery.request_success')}</div> : (
              <form onSubmit={this.submit}>
                {reset ? (
                  <div>
                    <p id="password-rules">{t('passwordRecovery.password_policy')}</p>
                    <div className="form-group">
                      <label htmlFor="new-password">{t('passwordRecovery.new_password')}</label>
                      <input id="new-password" type="password" autoComplete="new-password" className="form-control" required minLength={15} maxLength={128} aria-describedby="password-rules" value={password} onChange={event => this.setState({ password: event.target.value })} disabled={busy || !hasToken} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="confirm-password">{t('passwordRecovery.confirm_password')}</label>
                      <input id="confirm-password" type="password" autoComplete="new-password" className="form-control" required minLength={15} maxLength={128} value={confirmation} onChange={event => this.setState({ confirmation: event.target.value })} disabled={busy || !hasToken} />
                    </div>
                  </div>
                ) : (
                  <div>
                    <p id="recovery-help">{t('passwordRecovery.help')}</p>
                    <div className="form-group">
                      <label htmlFor="recovery-username">{t('login.username')}</label>
                      <input id="recovery-username" type="text" autoComplete="username" className="form-control" required maxLength={260} aria-describedby="recovery-help" value={username} onChange={event => this.setState({ username: event.target.value })} disabled={busy} />
                    </div>
                    <div className="form-group">
                      <label htmlFor="recovery-email">{t('passwordRecovery.email')}</label>
                      <input id="recovery-email" type="email" autoComplete="email" className="form-control" required maxLength={254} value={email} onChange={event => this.setState({ email: event.target.value })} disabled={busy} />
                    </div>
                  </div>
                )}
                <button type="submit" className="btn btn-success" disabled={busy || !ready || (reset && !hasToken)}>{t(busy ? 'passwordRecovery.pending' : reset ? 'passwordRecovery.save' : 'passwordRecovery.send')}</button>
              </form>
            )}
            <p style={{ marginTop: 20 }}><a href="/login">{t('passwordRecovery.back')}</a></p>
            {reset && !success && <p><Link to="/forgot-password">{t('passwordRecovery.forgot_title')}</Link></p>}
          </div>
        </div>
      </div>
    );
  }
}

export default translate(['common'])(PasswordRecovery);
